/** CoStar.Api.ListingAnalytics.ViewModels.Enums.Website */
export var Website;
(function (Website) {
    Website[Website["None"] = 0] = "None";
    Website[Website["LoopNet"] = 1] = "LoopNet";
    Website[Website["CityFeet"] = 10] = "CityFeet";
    Website[Website["CityfeetND"] = 20] = "CityfeetND";
    Website[Website["CoStarProperty_ListingDiamondAd"] = 30] = "CoStarProperty_ListingDiamondAd";
    Website[Website["CtxCampaignMail"] = 31] = "CtxCampaignMail";
    Website[Website["Showcase"] = 40] = "Showcase";
    Website[Website["CoStarSuite"] = 50] = "CoStarSuite";
    Website[Website["CoStarPropertyAd"] = 60] = "CoStarPropertyAd";
})(Website || (Website = {}));
/** CoStar.Api.ListingAnalytics.ViewModels.Enums.SourceDeviceType */
export var SourceDeviceType;
(function (SourceDeviceType) {
    SourceDeviceType[SourceDeviceType["None"] = 0] = "None";
    SourceDeviceType[SourceDeviceType["DesktopWeb"] = 1] = "DesktopWeb";
    SourceDeviceType[SourceDeviceType["MobileWeb"] = 2] = "MobileWeb";
    SourceDeviceType[SourceDeviceType["TabletWeb"] = 3] = "TabletWeb";
    SourceDeviceType[SourceDeviceType["MobileiOSApp"] = 4] = "MobileiOSApp";
    SourceDeviceType[SourceDeviceType["TabletiOSApp"] = 5] = "TabletiOSApp";
    SourceDeviceType[SourceDeviceType["MobileAndroidApp"] = 6] = "MobileAndroidApp";
    SourceDeviceType[SourceDeviceType["TabletAndroidApp"] = 7] = "TabletAndroidApp";
})(SourceDeviceType || (SourceDeviceType = {}));
/** CoStar.Api.ListingAnalytics.ViewModels.Enums.ImpressionType */
export var ImpressionType;
(function (ImpressionType) {
    ImpressionType[ImpressionType["None"] = 0] = "None";
    ImpressionType[ImpressionType["ViewedFromSearchResult"] = 1] = "ViewedFromSearchResult";
    ImpressionType[ImpressionType["ViewedFromEmail"] = 2] = "ViewedFromEmail";
    ImpressionType[ImpressionType["ViewedFromProspectListEmail"] = 3] = "ViewedFromProspectListEmail";
    ImpressionType[ImpressionType["ViewedFromEmailAlert"] = 4] = "ViewedFromEmailAlert";
    ImpressionType[ImpressionType["ViewedFromEmailCampaign"] = 5] = "ViewedFromEmailCampaign";
    ImpressionType[ImpressionType["ViewedViaListingWebsite"] = 6] = "ViewedViaListingWebsite";
    ImpressionType[ImpressionType["VideoView"] = 7] = "VideoView";
})(ImpressionType || (ImpressionType = {}));
/** CoStar.Api.ListingAnalytics.ViewModels.Enums.VisitorGroup */
export var VisitorGroup;
(function (VisitorGroup) {
    VisitorGroup[VisitorGroup["None"] = 0] = "None";
    VisitorGroup[VisitorGroup["Other"] = 1] = "Other";
    VisitorGroup[VisitorGroup["InCountyProfessional"] = 2] = "InCountyProfessional";
    VisitorGroup[VisitorGroup["OutCountyProfessional"] = 3] = "OutCountyProfessional";
    VisitorGroup[VisitorGroup["InCountyPrincipal"] = 4] = "InCountyPrincipal";
    VisitorGroup[VisitorGroup["OutCountyPrincipal"] = 5] = "OutCountyPrincipal";
})(VisitorGroup || (VisitorGroup = {}));
